// extracted by mini-css-extract-plugin
export default {"wrapper":"Loader_wrapper__sadND","loader":"Loader_loader__DwtSp","before":"Loader_before__zkuvW","after":"Loader_after__j9qAH","text":"Loader_text__C2DZZ"};